import { render, staticRenderFns } from "./FilterSummaryTermCompare.vue?vue&type=template&id=bcda4e5e&"
import script from "./FilterSummaryTermCompare.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryTermCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports